module.exports = __webpack_public_path__ + "img/branches.eef37244.svg";